//#region src/types/model/slice.ts
/**
* Display type for a Slice.
*
* More details: {@link https://prismic.io/docs/slice}
*/
const CustomTypeModelSliceDisplay = {
	List: "list",
	Grid: "grid"
};
//#endregion
exports.CustomTypeModelSliceDisplay = CustomTypeModelSliceDisplay;

//# sourceMappingURL=slice.cjs.map